import { SubscriptionsResponseModel } from 'data/entities/subscriptions.entity';
import { subscriptionssRepository } from 'data/repositories/subscriptions.repository';

export const getSubscriptions = async (): Promise<SubscriptionsResponseModel | null> => {
    try {
        const subscriptions = await subscriptionssRepository.getSubscriptions();
        if (!subscriptions) throw Error('User Porfile not found!');

        return subscriptions;
    } catch (message) {
        return null;
    }
};
